import React, { useContext } from 'react';
import GlobalContext from '../contexts/global.js';
import Pill from './Pill.js';

import '../styles/categoryPills.css';

/* Toggleable { key, value } options, the categories from the site config by default */
const CategoryPills = ({
    options,
    selected = [],
    onChange = () => {},
    showAllPill = false,
    sortCategories = false
}) => {
    const { globalContext } = useContext(GlobalContext);

    const categories = [ ...(options ?? globalContext?.categories ?? []) ].sort(
        sortCategories ? ({ value: valueA }, { value: valueB }) =>
            valueA.localeCompare(valueB)
        : () => 0
    );

    const toggle = (key) => {
        const next = selected.includes(key) ?
            selected.filter(selectedKey => selectedKey !== key) :
            [...selected, key];

        onChange(next);
    };

    return (
        <div className="category-pills">
            {
                showAllPill && (
                    <Pill
                        label="All"
                        active={selected.length === 0}
                        onClick={() => onChange([])}
                    />
                )
            }
            {
                categories.map(category => (
                    <Pill
                        key={category.key}
                        label={category.value}
                        active={selected.includes(category.key)}
                        onClick={() => toggle(category.key)}
                    />
                ))
            }
        </div>
    );
};

export default CategoryPills;
